import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { IAppVersion, IAppVersionListResponse, IAppVersionResponse } from '../../models/app-version.model';
import { CommonDataProvider } from './common.data-provider';
import { LoaderService } from '../loader.service';
import { Observable } from 'rxjs';
import { APP_VERSION_POST, APP_VERSION_GET } from '../../constants/app-version.constants';

@Injectable()
export class AppVersionDataProvider extends CommonDataProvider<IAppVersion> {
  constructor(http: HttpClient, loaderService: LoaderService) {
    super(http, loaderService);
  }

  public getAppVersion$(): Observable<IAppVersionListResponse> {
    return this.http.get<IAppVersionListResponse>(APP_VERSION_GET).pipe(catchError(this.handleError));
  }

  public postAppVersion$(body: IAppVersion): Observable<IAppVersionResponse> {
    return this.http.post<IAppVersionResponse>(APP_VERSION_POST, body).pipe(catchError(this.handleError));
  }
}
